import { supabase } from '@/shared/lib/supabase'
import type { AccessPass } from '@/shared/types/app.types'

// Access pass tables not in auto-generated database.types.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const db = supabase as any

export async function fetchActivePass(userId: string): Promise<AccessPass | null> {
  const { data, error } = await db.rpc('get_active_pass', { p_user_id: userId })
  if (error) throw error
  return data as AccessPass | null
}

export async function buyAccessPass(
  userId: string,
  type: '24h_pass' | '2h_pass',
  startTime?: Date
): Promise<{
  pass_id: string
  type: string
  started_at: string
  expires_at: string
  points_charged: number
  new_balance: number
  promoted: boolean
}> {
  const params: Record<string, unknown> = { p_user_id: userId, p_type: type }
  if (startTime) params.p_start_time = startTime.toISOString()
  const { data, error } = await db.rpc('buy_access_pass', params)
  if (error) throw error
  return data
}

export async function fetchTrialEligible(userId: string): Promise<boolean> {
  const { count, error } = await db
    .from('access_passes')
    .select('id', { count: 'exact', head: true })
    .eq('user_id', userId)
  if (error) return true // Fail open — show the card, RPC will guard
  return count === 0
}

export async function claimFreeTrial(userId: string): Promise<{
  pass_id: string
  type: string
  started_at: string
  expires_at: string
  points_charged: number
}> {
  const { data, error } = await db.rpc('claim_free_trial', { p_user_id: userId })
  if (error) throw error
  return data
}

export async function subscribeWithPoints(userId: string): Promise<{
  membership_id: string
  start_date: string
  end_date: string
  points_charged: number
  new_balance: number
  is_renewal: boolean
}> {
  const { data, error } = await db.rpc('subscribe_with_points', { p_user_id: userId })
  if (error) throw error
  return data
}
